import { Component } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { Address } from '@app/shared/models/address';
import { OpData} from '@app/core/services/base/base-service-with-bundle.service';

@Component({
    selector: 'address-twb',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent extends TwoWayBoundComponent<Address> {

    get address(): Address {
        return this.bananaBox;
    }

    constructor() {
        super();
    }

    public onCountryChange(opDataArray: OpData[]): void {
        if (opDataArray) {
            const countryCodeOp = opDataArray.find(op => op.path === 'country/code');
            this.address.countryCode = countryCodeOp ? countryCodeOp.value : '';
            this.address.country_code = this.address.countryCode;

            const countryValueOp = opDataArray.find(op => op.path === 'country/value');
            this.address.country = countryValueOp ? countryValueOp.value : '';
            this.onChange();
        }
    }
}
